import { createContext } from 'react';
/**
 * This context is used for getting suggestions on autocomplete search.
 * @example
 * const autocomplete = useContext(AutocompleteContext);
 * autocomplete(inputText).then(result => ...)
 */

var AutocompleteContext = createContext(null);
export default AutocompleteContext;